module.exports = __webpack_public_path__ + "static/media/withdraw_voice.43950ef.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audio/withdraw_voice.mp3
// module id = qUm0
// module chunks = 1